var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.821 6.22H6.538V4.634c0-.747.457-.92.779-.92h2.298V.426l-3.33-.01c-3.02 0-3.593 2.449-3.593 4.017v1.787H.384v3.333h2.308v10h3.846v-10H9.5l.321-3.333z"}));
}

Facebook.defaultProps = {"width":"10","height":"20"};

module.exports = Facebook;

Facebook.default = Facebook;
